import { CatalogFilters } from '../../hooks/useCatalogFilters';
import { AGE_BUCKETS } from '../../constants/ageBuckets';
import { AGE_VARIATION_TYPE } from '../../utils/variantResolution';
import { FILTER_CHIP_ACTIVE_CLASS, FILTER_CHIP_CLASS, FILTER_CHIP_INACTIVE_CLASS } from './filterChipStyles';

function sameValues(a: string[], b: string[]): boolean {
  return a.length === b.length && a.every((value) => b.includes(value));
}

export function AgeBucketChips({ filters }: { filters: CatalogFilters }) {
  return (
    <>
      {AGE_BUCKETS.map((bucket) => {
        const active =
          filters.variationTypeId === AGE_VARIATION_TYPE && sameValues(filters.variationValues, bucket.variationValues);
        return (
          <button
            key={bucket.key}
            type="button"
            aria-pressed={active}
            onClick={() =>
              active
                ? filters.handleVariationSelect(AGE_VARIATION_TYPE, [])
                : filters.handleVariationSelect(AGE_VARIATION_TYPE, bucket.variationValues)
            }
            className={[
              FILTER_CHIP_CLASS,
              'shrink-0 whitespace-nowrap',
              active ? FILTER_CHIP_ACTIVE_CLASS : FILTER_CHIP_INACTIVE_CLASS,
            ].join(' ')}
          >
            {bucket.label}
          </button>
        );
      })}
    </>
  );
}
